import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { ArrowLeft } from "lucide-react";

export default function Impressum() {
  useEffect(() => {
    document.title = "Impressum | Wagenhofer Capital";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-black text-white min-h-screen">
      <Navigation />

      <section className="pt-40 pb-24 border-b border-white/5">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Link
            to="/"
            data-testid="impressum-back"
            className="inline-flex items-center gap-2 text-xs tracking-[0.28em] uppercase text-zinc-400 hover:text-[#D4AF37] transition-colors mb-12"
          >
            <ArrowLeft className="w-3.5 h-3.5" strokeWidth={1.5} />
            Zurück
          </Link>
          <div className="overline mb-6">Rechtliches</div>
          <h1
            data-testid="impressum-headline"
            className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tighter font-medium leading-[1.02] mb-10"
          >
            Impressum
          </h1>
          <span className="block w-12 h-px bg-[#D4AF37]" />
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 space-y-12 text-zinc-300 leading-relaxed font-light">
          <div>
            <h2 className="font-display text-xl md:text-2xl font-medium text-white mb-4">
              Angaben gemäß § 5 TMG
            </h2>
            <address className="not-italic">
              Wagenhofer Capital GmbH
              <br />
              Max-Löw-Straße 27
              <br />
              85579 Neubiberg
              <br />
              Deutschland
            </address>
          </div>

          <div>
            <h2 className="font-display text-xl md:text-2xl font-medium text-white mb-4">
              Vertreten durch
            </h2>
            <p>Leo Wagenhofer</p>
          </div>

          <div>
            <h2 className="font-display text-xl md:text-2xl font-medium text-white mb-4">
              Kontakt
            </h2>
            <p>
              E-Mail:{" "}
              <a
                href="mailto:muenchen@wagenhofer.capital"
                className="text-zinc-200 hover:text-[#D4AF37] transition-colors"
              >
                muenchen@wagenhofer.capital
              </a>
            </p>
          </div>

          <div>
            <h2 className="font-display text-xl md:text-2xl font-medium text-white mb-4">
              Handelsregister
            </h2>
            <p>
              Eingetragen im Handelsregister.
              <br />
              Registergericht: Amtsgericht München
              <br />
              Registernummer: HRB 314479
            </p>
          </div>

          <div>
            <h2 className="font-display text-xl md:text-2xl font-medium text-white mb-4">
              Steuernummer
            </h2>
            <p>143/191/20220</p>
          </div>

          <div>
            <h2 className="font-display text-xl md:text-2xl font-medium text-white mb-4">
              Umsatzsteuer-ID
            </h2>
            <p>
              Umsatzsteuer-Identifikationsnummer gemäß § 27a
              Umsatzsteuergesetz:
              <br />
              DE465231267
            </p>
          </div>

          <div>
            <h2 className="font-display text-xl md:text-2xl font-medium text-white mb-4">
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <p>
              Leo Wagenhofer
              <br />
              Wagenhofer Capital GmbH
              <br />
              Max-Löw-Straße 27
              <br />
              85579 Neubiberg
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
